//--sound
import { SoundProvider, useSound } from '../components/sound/soundContext';
//other
import React, { useState, useRef, useEffect} from 'react';
import OCTemplate from '../components/ocTemplate';
import { getImagePaths, loadImages } from '../utils/imageLoader';
import imageConfig from "../config/json/imageConfig.json";

const OCPage = ({ theme, onBackClick, }) => {
  const [isOC1Blinking, setIsOC1Blinking] = useState(false);
  const [isOC2Blinking, setIsOC2Blinking] = useState(false);
  const [isOC3Blinking, setIsOC3Blinking] = useState(false);
  const [isOC4Blinking, setIsOC4Blinking] = useState(false);

  const [ocImages, setOCImages] = useState(null);
  const {playPopSound}= useSound();

  //Load images on component mount
  useEffect(() => {
    const loadOcImages = async () => {
      const images = await loadImages('ocs');
      const mappedImages={};
      const ocKeys = Object.keys(imageConfig.ocs);

      images.forEach((imgModule, index) => {
        mappedImages[ocKeys[index]] = imgModule;
      });
      setOCImages(mappedImages);
    };
    loadOcImages();
  }, []);

  //helps to click and scroll down to the appropriate character
  const jackRef = useRef(null);
  const renaRef = useRef(null);
  const xofiiRef = useRef(null);
  const makotoRef = useRef(null);

  const handleOC1Click = () => {
    playPopSound();
    console.log('OC clicked, navigating to OC info');
    setIsOC1Blinking(true);
    setTimeout(() => setIsOC1Blinking(false), 300);
    jackRef.current?.scrollIntoView({ behavior: 'smooth' });
  };
  const handleOC2Click = () => {
    playPopSound();
    console.log('OC clicked, navigating to OC info');
    setIsOC2Blinking(true);
    setTimeout(() => setIsOC2Blinking(false), 300);
    renaRef.current?.scrollIntoView({ behavior: 'smooth' });
  };
  const handleOC3Click = () => {
    playPopSound();
    console.log('OC clicked, navigating to OC info');
    setIsOC3Blinking(true);
    setTimeout(() => setIsOC3Blinking(false), 300);
    xofiiRef.current?.scrollIntoView({ behavior: 'smooth' });
  };
  const handleOC4Click = () => {
    playPopSound();
    console.log('OC clicked, navigating to OC info');
    setIsOC4Blinking(true);
    setTimeout(() => setIsOC4Blinking(false), 300);
    makotoRef.current?.scrollIntoView({ behavior: 'smooth' });
  };
  if (!ocImages) {
    return <div>Loading characters...</div>;
  }
  return (
      <div className='ocpage'>
        <h3>My Original characters</h3>
        <p>I have made plenty over the years. Many of them have become their own individuals. Here are few of my favorites. Click on the images below to learn more about them!</p>
        <div className='ocRow'>
          <button>
            <img 
              src={
                isOC1Blinking
                ?(theme === 'light'? ocImages.jackBlinkDay : ocImages.jackBlinkNight)
                :(theme === 'light'? ocImages.jackDay : ocImages.jackNight)
              }
              className="ocClick" 
              alt="clickable oc Jack"
              onMouseEnter={() => setIsOC1Blinking(true)}
              onMouseLeave={() => setIsOC1Blinking(false)}
              onClick={(e) => {
                e.stopPropagation()//prevent event bubbling
                handleOC1Click();
              }}
            />
          </button>
          <button>
            <img 
              src={
                isOC2Blinking
                ?(theme === 'light'? ocImages.renaBlinkDay : ocImages.renaBlinkNight)
                :(theme === 'light'? ocImages.renaDay : ocImages.renaNight)
              }
              className="ocClick" 
              alt="clickable oc Rena"
              onMouseEnter={() => setIsOC2Blinking(true)}
              onMouseLeave={() => setIsOC2Blinking(false)}
              onClick={(e) => {
                e.stopPropagation()//prevent event bubbling
                handleOC2Click();
              }}
            />
          </button>
          <button>
            <img 
              src={
                isOC3Blinking
                ?(theme === 'light'? ocImages.xofiiBlinkDay : ocImages.xofiiBlinkNight)
                :(theme === 'light'? ocImages.xofiiDay : ocImages.xofiiNight)
              }
              className="ocClick" 
              alt="clickable oc Xofii"
              onMouseEnter={() => setIsOC3Blinking(true)}
              onMouseLeave={() => setIsOC3Blinking(false)}
              onClick={(e) => {
                e.stopPropagation()//prevent event bubbling
                handleOC3Click();
              }}
            />
          </button>
          <button>
            <img 
              src={
                isOC4Blinking
                ?(theme === 'light'? ocImages.makotoDayMask : ocImages.makotoNightMask)
                :(theme === 'light'? ocImages.makotoDay : ocImages.makotoNight)
              }
              className="ocClick" 
              alt="clickable oc Makoto"
              onMouseEnter={() => setIsOC4Blinking(true)}
              onMouseLeave={() => setIsOC4Blinking(false)}
              onClick={(e) => {
                e.stopPropagation()//prevent event bubbling
                handleOC4Click();
              }}
            />
          </button>
          <div ref={jackRef}>
            <OCTemplate 
                theme={theme}
                name="Jack Tran"
                image={theme === 'light' ? ocImages.jackDay : ocImages.jackNight}
                description="At the behest of a mysterious fairy with a strange offer, with nothing to lose, Jack journeys to the other side of the Great Fissure to get answers to his mother's disappearance, his father's murder, and his supposed connection to the world of sorcery. His real name is Jack Tran. Jack Hollow is is the stage name he uses as a registered sorcerer."
                onClick={handleOC1Click}
                index={0}
            />
          </div>
          <div ref={renaRef}>
            <OCTemplate 
                theme={theme}
                name="Rena"
                image={theme === 'light' ? ocImages.renaDay : ocImages.renaNight}
                description="Current ruler of the Onneran people, Rena struggles to ensure their survival. She currently searches the cosmos for the once infamous warrior Gan the Barbarian, the father of her child."
                onClick={handleOC2Click}
                index={1}
            />
          </div>
          <div ref={xofiiRef}>
            <OCTemplate 
                theme={theme}
                name="Xofii Cyclops"
                image={theme === 'light' ? ocImages.xofiiDay : ocImages.xofiiNight}
                description="Xofii, like the rest of her family, can see the magic permeate the world around him. As new folks in town, Xofii is determined to help her new friends see that the world is more interesting than they realize."
                onClick={handleOC3Click}
                index={2}
            />
          </div>
          <div ref={makotoRef}>
            <OCTemplate 
                theme={theme}
                name="Makoto Takaga"
                image={theme === 'light' ? ocImages.makotoDay : ocImages.makotoNight}
                description="With control over shadow and fire, and born into a wealthy family, Makoto deals with how to present himself to the world around him while learning how to control the volitility of his powers."
                onClick={handleOC4Click}
                index={3}
            />
          </div>
        </div>
      </div>
    );
  };
  
  export default OCPage;